<template>

    <div class="relative flex flex-col justify-center w-11/12" :class="computedContainerClasses">
        <p v-if="medias.length > 0" class="text-right text-sm px-2 py-1 text-gray-600">            
            <em>Clique na imagem <span v-show="$props.showThumbs && medias.length > 1">ou nas miniaturas</span> para dar zoom</em>            
        </p>
        <ul v-show="$props.showThumbs && medias.length > 1" class="absolute bottom-14 left-2 flex z-10 space-x-1 mt-1">
            <li 
                v-for="(item, index) in medias"
                :key="`${galleryID}-thumb-${index}`"
                
            >
                <img 
                    class="border-white border-2 cursor-pointer" 
                    :src="item.thumb_src || item.cover_thumb_src" 
                    :alt="item.title"

                    @click="activateZoom(index)"
                >
            </li>
        </ul>

        <div :id="id" class="flex justify-center" :class="computedGalleryClasses">
        
            <a v-for="(item, index) in medias" 
               v-show="index < $props.hideSince"
                :key="`${galleryID}-${index}`"
                :href="item.max_size_src || item.src"
                :title="item.title"
                class="flex"
                :class="computedZoomImageClasses"
            >          
        
                <figure class="relative" :class="computedImageContainerClasses">                
                    <img :src="item.max_size_src || item.cover_max_size_src " class="rounded-xl" :class="computedImageClasses" :alt="item.title"/>
                    <figcaption class="absolute rounded-b-xl bottom-0 bg-brand bg-opacity-60 px-3 py-2 w-full text-white font-bold text-sm lg:text-base xl:text-lg">
                        {{ item.title }}
                    </figcaption>
                </figure>
               
            </a>               
        </div>
    </div>

</template>

<script>

import { onMounted } from 'vue';
import randomstring from 'randomstring';

import 'lightgallery.js/dist/css/lightgallery.min.css'

import 'lightgallery.js'
import 'lg-thumbnail.js'
import 'lg-autoplay.js'
import 'lg-video.js'
import 'lg-fullscreen.js'
import 'lg-zoom.js'

import { classes2Object } from '@/helpers'

export default {

    props: {
        galleryID: { type: String, default: '' },
        options: { type: Object, default: () => {} },
        medias: { type: Array, required: true }, 
        hideSince: { type: Number, default: 1 },


        galleryClasses: { type: String, default: '' },
        containerClasses: { type: String, default: '' },
        zoomImageClasses: { type: String, default: '' },
        imageContainerClasses: { type: String, default: '' },
        imageClasses: { type: String, default: '' },
        showThumbs: { type: Boolean, default: false }

    },

    setup (props) {
        
        const galleryID = props.galleryID || `gallery-${randomstring.generate(5)}`

        const computedContainerClasses = classes2Object(props.containerClasses)
        const computedGalleryClasses = classes2Object(props.galleryClasses)
        const computedZoomImageClasses = classes2Object(props.zoomImageClasses)
        const computedImageContainerClasses = classes2Object(props.imageContainerClasses)
        const computedImageClasses = classes2Object(props.imageClasses)

        onMounted(() => {
            const gallery = document.querySelector(`#${galleryID}`)
            window.lightGallery(gallery, {...props.options})
        })
        
        function activateZoom(index)
        {
            document.querySelector(`#${galleryID} a:nth-child(${index + 1})`).click()
        }

        return {
            id: galleryID,
            computedContainerClasses,
            computedGalleryClasses,
            computedZoomImageClasses,
            computedImageContainerClasses,
            computedImageClasses,
            activateZoom
        }
    }
    
}
</script>

<style lang="css" scoped>
</style>